import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'gdp-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent {
  public message: string;
  public params: Record<string, string> = {};

  constructor(private activeModal: NgbActiveModal) {}

  close() {
    this.activeModal.close('close');
  }

  ok() {
    this.activeModal.close('ok');
  }

}
